export default {
    ratings: {
        overrall: {
            text: 'Overral satisfaction with referral',
        },
        physician: {
            office: {
                text: 'How was the office environment?',
            },
            staff: {
                text: 'Was the staff friendly and courteous',
            },
            wait_time: {
                text: 'How was the in-office wait time?',
            },
            trust: {
                text: 'How was the level of trust?',
            },
            explanation: {
                text: "Were you happy with provider's explanation?",
            },
            listening: {
                text: 'Did the provider listen and answer your questions to your satisfaction?',
            },
            time_spent: {
                text: 'Were you happy with the time the provider spent with you?',
            },
        },
        ancillary: {
            facility: {
                text: 'How was the environment of the facility?',
            },
            staff: {
                text: 'Was the staff friendly and courteous',
            },
            wait_time: {
                text: 'How was the in-office wait time?',
            },
            refer: {
                text: 'How likely are to refer a patient to this facility?',
            },
        },
    },
    thank_you_for_rating: 'Thank you for rating {referredToName}',
    please_rate_physician: 'Please rate your visit with {referredToName}',
    please_rate_ancillary: 'Please rate your experience with {referredToName}',
    rate_on_scale_1: '1 = Not happy',
    rate_on_scale_5: '5 = Excellent',
}
